import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { MobileContactBar } from "./MobileContactBar";
import { CookieConsent } from "../CookieConsent";
import { captureAttribution } from "../../lib/api";

export const Layout = ({ children }) => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (typeof window.gtag === "function" && window.__ga4_loaded) {
      window.gtag("event", "page_view", { page_path: pathname });
    }
  }, [pathname]);
  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
      return undefined;
    }
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  useEffect(() => { captureAttribution(); }, []);

  if (pathname.startsWith("/admin")) return <div className="min-h-screen bg-slate-50">{children}</div>;
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] btn-primary">Naar de inhoud</a>
      <SiteHeader />
      <main id="main" className="flex-1">{children}</main>
      <SiteFooter />
      <MobileContactBar />
      <CookieConsent />
    </div>
  );
};
